<template>
  <div>

    <div id="pag"></div>
  
  <div class="page-wrap">
    
    <section class="pixelsbg bs-shadow" style="padding: 30px 0px 20px;">
      <fort-hero />
      <div class="container">
        <div class="award-panel">

          <h2 class="text-white mb0" style="margin-top: 0px; margin-bottom: 0;">
            {{ userName || "Points History" }} <small
              style="font-weight: 300; color: rgba(255, 255, 255, 0.75); font-size: 18px"> - {{ company }}</small>
          </h2>
          <!-- Totals -->
          <div class="row" style="margin-top: 10px; margin-bottom: 0;">
            <div class="col-12 col-sm-12 col-lg-4">
              <div class="stat-box mb-2 bs-shadow">
                <h3>{{ totals.quiz }}</h3>
                <p class="mb0">Quiz Points{{ yearLabel }}</p>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-lg-4">
              <div class="stat-box mb-2 bs-shadow">
                <h3>{{ totals.event }}</h3>
                <p class="mb0">Event Points{{ yearLabel }}</p>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-lg-4">
              <div class="stat-box mb-2 bs-shadow">
                <h3>{{ totals.all }}</h3>
                <p class="mb0">Total Points{{ yearLabel }}</p>
              </div>
            </div>
          </div>



          <a href="#" class="back-link" @click.prevent="goBack">
            <span class="material-icons">arrow_back</span> Back
          </a>
        </div>
      </div>
    </section>

    <!-- bottom -->
    <div class="container">
      <TrainingPagination :currPage="currPage" :totalPage="totalPage" :filteredPosts="filteredRows" :setPage="setPage"
        :countOfPage="countOfPage" class="mb10" />

      <div style="background-color: #fff; line-height: 1; padding: 20px;">
        <div class="d-flex align-items-center filters" style="margin-bottom: 20px;">
          <h2 class="mb0">Quizzes &amp; Events</h2>

          <select class="form-control mlauto" style="max-width: 160px;" v-model="yearFilter">
            <option value="">All years</option>
            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
          </select>
          <button type="button" class="csv-btn" :disabled="loading || !filteredRows.length" @click="downloadCSV">
            <span class="material-icons">download</span> Download CSV
          </button>

          <!--
           <select class="form-control" style="max-width: 160px;" v-model="typeFilter">
            <option value="">Quizzes &amp; events</option>
            <option value="Quiz">Quizzes</option>
            <option value="Event">Events</option>
          </select>

          <input
            class="form-control"
            style="max-width: 240px;"
            v-model="textFilter"
            placeholder="Filter by title"
          />
          
          -->

        </div>

        <div v-if="loading" class="flexVHcenter" style="min-height: 200px;">
          <p>Loading…</p>
        </div>

        <table v-else-if="paginatedRows.length" class="table-striped table-bordered"
          style="display: table; width: 100%;">
          <thead>
            <tr>
              <th @click="sortCol('Added')" class="table-link" :class="{ 'column-active': columnSort === 'Added' }"
                style="width: 14%;">
                Date
              </th>
              <th @click="sortCol('Type')" class="table-link" :class="{ 'column-active': columnSort === 'Type' }"
                style="width: 10%;">
                Type
              </th>
              <th @click="sortCol('Title')" class="table-link" :class="{ 'column-active': columnSort === 'Title' }">
                Title
              </th>
              <th @click="sortCol('Year')" class="table-link" :class="{ 'column-active': columnSort === 'Year' }"
                style="width: 10%;">
                Year
              </th>
              <th @click="sortCol('Points')" class="table-link" :class="{ 'column-active': columnSort === 'Points' }"
                style="width: 10%;">
                Points
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in paginatedRows" :key="`${r.Type}-${r.Added}-${i}`">
              <td>{{ $moment(r.Added).format("MM-DD-YYYY") }}</td>
              <td>
                <span class="type-pill" :class="r.Type === 'Quiz' ? 'type-quiz' : 'type-event'">
                  {{ r.Type }}
                </span>
              </td>
              <td>{{ r.Title || "—" }}</td>
              <td>{{ r.Year }}</td>
              <td>{{ r.Points }}</td>
            </tr>
          </tbody>
        </table>

        <p v-else class="hint-dark" style="margin: 20px 0;">No quizzes or events to show.</p>
      </div>

      <TrainingPagination :currPage="currPage" :totalPage="totalPage" :filteredPosts="filteredRows" :setPage="setPage"
        :countOfPage="countOfPage" class="mt10" style="margin-bottom: 20px!important;" />
    </div>
  </div>
  </div>
</template>

<script>
import { checkTokenOrLogout } from '@/utils/auth';
import axios from "axios";
import TrainingPagination from "@/components/Pagination/TrainingPagination.vue";
import FortHero from "@/components/heroes/FortHero.vue";

const auth = () => ({
  headers: { Authorization: "Bearer " + localStorage.getItem("SSCUSER") },
});

export default {
  name: "FortLearningUserPoints",
  components: { TrainingPagination, FortHero },
  data() {
    return {
      // server: import.meta.env.VITE_APP_SERVER_URL,
      server: "http://localhost:5002",
      rows: [],
      loading: false,
      // Passed in the link from the reps table: ?name=Jane%20Smith&company=Acme
      userName: this.$route.query.name || "",
      company: this.$route.query.company || "",
      yearFilter: "",
      typeFilter: "",
      textFilter: "",
      currPage: 1,
      countOfPage: 50,
      columnSort: "Added",
      colSort: true,
    };
  },
  computed: {
    userId() {
      return this.$route.params.userid;
    },
    years() {
      return [...new Set(this.rows.map(r => r.Year))].sort((a, b) => b - a);
    },
    yearLabel() {
      return this.yearFilter ? ` (${this.yearFilter})` : " (All Years)";
    },
    // Totals follow the year filter only, so they don't change when you search titles
    totals() {
      const inYear = this.rows.filter(r => !this.yearFilter || r.Year === this.yearFilter);
      const sum = type =>
        inYear.filter(r => !type || r.Type === type).reduce((a, r) => a + (Number(r.Points) || 0), 0);
      return { quiz: sum("Quiz"), event: sum("Event"), all: sum() };
    },
    filteredRows() {
      const term = this.textFilter.trim().toLowerCase();
      return this.rows.filter(r =>
        (!this.yearFilter || r.Year === this.yearFilter) &&
        (!this.typeFilter || r.Type === this.typeFilter) &&
        (!term || (r.Title || "").toLowerCase().includes(term))
      );
    },
    pageStart() {
      return (this.currPage - 1) * this.countOfPage;
    },
    totalPage() {
      return Math.ceil(this.filteredRows.length / this.countOfPage) || 1;
    },
    paginatedRows() {
      return this.filteredRows.slice(this.pageStart, this.pageStart + this.countOfPage);
    },
  },
  methods: {
    getPoints() {
      if (!this.userId) return;
      this.loading = true;
      return axios
        .get(`${this.server}/api/v1/training-points-history/${encodeURIComponent(this.userId)}`, auth())
        .then(res => {
          const { user, points } = res.data || {};
          this.rows = points || [];
          if (user) {
            this.userName = `${user.FirstName} ${user.LastName}`.trim();
            this.company = user.Company || "";
          }
        })
        .catch(this.handleError)
        .finally(() => { this.loading = false; });
    },
    downloadCSV() {
      const rows = this.filteredRows;
      if (!rows.length) return;

      // Quote every cell, double up quotes, and stop Excel treating text as a formula
      const cell = value => {
        let s = String(value ?? "");
        if (/^[=+\-@]/.test(s)) s = "'" + s;
        return `"${s.replace(/"/g, '""')}"`;
      };

      const header = ["Date", "Type", "Title", "Year", "Points"];
      const lines = rows.map(r => [
        this.$moment(r.Added).format("MM-DD-YYYY"),
        r.Type,
        r.Title || "",
        r.Year,
        r.Points,
      ].map(cell).join(","));

      // Total row at the bottom
      const total = rows.reduce((sum, r) => sum + (Number(r.Points) || 0), 0);
      lines.push(["", "", "Total", "", total].map(cell).join(","));

      // \uFEFF tells Excel the file is UTF-8, so names with accents display correctly
      const csv = "\uFEFF" + [header.map(cell).join(","), ...lines].join("\r\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      const safeName = (this.userName || "user").replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "");
      const yearPart = this.yearFilter || "all-years";
      const filename = `${safeName}-points-${yearPart}.csv`;

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    goBack() {
      // Vue Router 4 records the previous in-app page in history.state.back
      if (window.history.state && window.history.state.back) {
        this.$router.back();
      } else {
        this.$router.push("/fortified-learning/admin/events");
      }
    },
    setPage(idx) {
      if (idx <= 0 || idx > this.totalPage) return;
      this.currPage = idx;
    },
    sortCol(type) {
      // Clicking a new column starts descending for dates/numbers, ascending for text
      if (this.columnSort !== type) {
        this.colSort = !["Added", "Points", "Year"].includes(type);
      }
      this.columnSort = type;
      const dir = this.colSort ? 1 : -1;
      this.rows.sort((a, b) => {
        let av = a[type] ?? "";
        let bv = b[type] ?? "";
        if (type === "Added") {
          av = new Date(av).getTime();
          bv = new Date(bv).getTime();
        }
        if (typeof av === "number" && typeof bv === "number") return (av - bv) * dir;
        return String(av).localeCompare(String(bv)) * dir;
      });
      this.colSort = !this.colSort;
    },
    handleError(error) {
      if (error.request?.status === 401) {
        this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
        this.$router.push("/");
        return;
      }
      this.$toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
    },
  },
  created() {
		if (checkTokenOrLogout()) return;
		this.$store.commit("showNavigation");
	},
  mounted() {
    this.getPoints();
    // const el = document.getElementById("pag");
    // el.scrollIntoView({ behavior: "smooth" });
  },
  watch: {
    yearFilter() { this.currPage = 1; },
    typeFilter() { this.currPage = 1; },
    textFilter() { this.currPage = 1; },
    // Reload if you navigate from one user's page straight to another's
    "$route.params.userid"() {
      this.userName = this.$route.query.name || "";
      this.company = this.$route.query.company || "";
      this.rows = [];
      this.yearFilter = "";
      this.getPoints();
    },
  },
};
</script>

<style scoped>
.award-panel {
  background: transparent;
  padding: 0;
  color: #fff;
  line-height: 1.2;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 15px;
}

.back-link:hover {
  color: #fff;
  text-decoration: none;
}

.back-link .material-icons {
  font-size: 18px;
}

.hint {
  display: block;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.95em;
}

.hint-dark {
  color: #777;
}

.stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.stat {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  padding: 14px 20px;
  min-width: 170px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stat-num {
  font-size: 30px;
  font-weight: 500;
  color: #fff;
}

.stat-label {
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.85);
}

.filters {
  flex-wrap: wrap;
  gap: 10px;
}

.type-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 13px;
  color: #fff;
}

.type-quiz {
  background: #429da8;
}

.type-event {
  background: #4d5967;
}

thead th {
  border-bottom-width: 2px;
  color: #fff;
  padding: 5px;
  font-weight: 300 !important;
}

.stat-box {
  padding: 20px;
  text-align: center;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 4px;
}

.stat-box p {
  font-weight: 300;
}
.csv-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 0 14px;
  height: 38px;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
}
.csv-btn:hover {
  background: #586575;
}
.csv-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
.csv-btn .material-icons {
  font-size: 18px;
}
.page-wrap {
  min-height: 100vh;
}
</style>
